import { render, staticRenderFns } from "./ShowNotesOfPoint.vue?vue&type=template&id=653abf42&"
import script from "./ShowNotesOfPoint.vue?vue&type=script&lang=js&"
export * from "./ShowNotesOfPoint.vue?vue&type=script&lang=js&"
import style0 from "./ShowNotesOfPoint.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports